<div class="container-view e11-h-screen">
  <app-header-unauthenticated> </app-header-unauthenticated>

  <main class="registration">
    <div class="e11-container e11-mx-auto">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
